import styled from '@emotion/styled';
import React, {useContext, useState} from 'react';

import { Box } from '@mui/system';
import { Tab, Tabs } from '@mui/material';
import { useTheme } from '@emotion/react';
import { Route, Routes, useNavigate,Navigate } from 'react-router-dom';
import RequireAuth from '../../components/RequireAuth';
import useAuth from '../../hooks/useAuth';
import CourseOffering from './CourseOffering'
import CoursePreferenceTable from '../../components/tables/100/CoursePreferenceTable';
export default function CoursePreference() {
  const navigate=useNavigate();
  const InfoWrapper=styled(Box)({
    width:'100%',
    marginLeft:'10px',
    display:'flex',
    flexDirection:'column',

  })
  const [table,setTable]=useState(window.location.pathname)
  const HandleChange = (event, newValue) => {
    setTable(newValue);
    navigate(newValue);
  };
  return (
    <>
    <InfoWrapper>
      <Tabs
          value={table}
          onChange={HandleChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="secondary tabs example"
          sx={{
              fontFamily: 'Poppins',
              fontStyle: "normal",
              fontWeight: 700,
              fontSize: "18px",
              margin:"5px"
          }}
        >
        <Tab value="/offering" label="Regular Courses" />
        <Tab value="/offering/extension" label="Extension Courses" />
        <Tab value="/offering/history" label="Preference History" />
        </Tabs>
       <Routes>
        <Route element={<RequireAuth allowedRoles={[112]}/>}>
        <Route exact index element={ <CourseOffering type="Regular"/>} />
        </Route>
        <Route element={<RequireAuth allowedRoles={[112]}/>}>
        <Route exact path="/extension" element={ <CourseOffering type="Extension"/>} />
        </Route>
        <Route element={<RequireAuth allowedRoles={[112]}/>}>
        <Route exact path="/history" element={ <CoursePreferenceTable />} />
        </Route>
      </Routes>  
    </InfoWrapper>
  
    
    </>
  )
}
